import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '@app-core/constants/api.constants';
import { DEFAULT_DATA_RETENTION_DAYS, DEFAULT_DURATION_LIST } from '@app-core/constants/constants';
import { ClientConfigResponse, Duration } from '@app-core/models/core.model';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';

// todo - refactor portal notification settings in a separate service for better logical separation
@Injectable({
  providedIn: 'root',
})
export class DurationRangeService {
  private durationList: Duration[] = DEFAULT_DURATION_LIST;

  private _dataRetentionDays: number = DEFAULT_DATA_RETENTION_DAYS;

  private _includePolylinePathInfo: boolean = false;

  private _webRTCLiveStreamingEnabled: boolean = false;
  private _disableSuprsendNotification: boolean = false;
  private _planDetails;
  private _plan;
  private _reportsLogoS3Url;

  private _supportAsyncAssetReport: boolean;
  private _triagingEnabled: boolean = false;

  private _autoRefreshEnabled: boolean = false;

  public get dataRetentionDays() {
    return this._dataRetentionDays;
  }

  public get disableSuprsendNotification() {
    return this._disableSuprsendNotification;
  }

  public get planDetails() {
    return this._planDetails;
  }

  public get reportsLogoS3Url() {
    return this._reportsLogoS3Url;
  }
  public get plan() {
    return this._plan;
  }

  public get includePolylinePathInfo() {
    return this._includePolylinePathInfo;
  }

  public get supportAsyncAssetReport() {
    return this._supportAsyncAssetReport;
  }

  public get autoRefreshEnabled() {
    return this._autoRefreshEnabled;
  }

  public set dataRetentionDays(value: number) {
    this._dataRetentionDays = value;
    this.updateDurationList();
  }

  public set includePolylinePathInfo(value: boolean) {
    this._includePolylinePathInfo = value;
  }

  public get webRTCLiveStreamingEnabled() {
    return this._webRTCLiveStreamingEnabled;
  }

  public get triagingEnabled() {
    return this._triagingEnabled;
  }

  public set disableSuprsendNotification(value) {
    this._disableSuprsendNotification = value;
  }
  constructor(private http: HttpClient) {}

  public getDurationList(): Duration[] {
    return this.durationList;
  }

  public updateDurationList() {
    this.durationList = this.getCustomDurationList(this.durationList, this.dataRetentionDays);
  }

  public getCustomDurationList(customDurationList: Duration[], dataRetentionPeriod = this.dataRetentionDays): Duration[] {
    let verifiedList = customDurationList.filter((item: Duration) => {
      if (item.days === 'custom' || item.days === 'yesterday') {
        return true;
      } else if (typeof item.days === 'number') {
        return item.days <= dataRetentionPeriod;
      }
      return false;
    });
    return verifiedList;
  }

  public getClientConfig(): Observable<ClientConfigResponse> {
    return this.http.get<ClientConfigResponse>(API.CLIENT_CONFIG).pipe(
      shareReplay({ bufferSize: 1, refCount: true }),
      tap((res: ClientConfigResponse) => {
        const {
          dataRetention = DEFAULT_DATA_RETENTION_DAYS,
          includePolylinePathInfo = false,
          disableSuprsend = false,
          webRTCLiveStreamingEnabled = false,
          planDetails,
          plan,
          supportAsyncAssetReport = false,
          reportsLogoS3Url,
          autoRefreshEnabled = false,
          triagingEnabled = false,
        } = res?.data || {};
        this.dataRetentionDays = dataRetention;
        this.includePolylinePathInfo = includePolylinePathInfo;
        this._webRTCLiveStreamingEnabled = webRTCLiveStreamingEnabled;
        this._disableSuprsendNotification = disableSuprsend;
        this._planDetails = planDetails || null;
        this._plan = plan;
        this._supportAsyncAssetReport = supportAsyncAssetReport;
        this._reportsLogoS3Url = reportsLogoS3Url;
        this._autoRefreshEnabled = autoRefreshEnabled;
        this._triagingEnabled = triagingEnabled;
      }),
      catchError(() => {
        this.dataRetentionDays = DEFAULT_DATA_RETENTION_DAYS;
        this.includePolylinePathInfo = false;
        this._supportAsyncAssetReport = false;
        return of(null);
      })
    );
  }
}
